import axios from "axios";

import {IFeed, IPartner, ITheme, IIntroductionPanel} from "@/models/vimy.models";
import {VuexModule, Module, Mutation, Action} from "vuex-class-modules";
import {EventStore} from ".";

@Module
export class DataModule extends VuexModule {
  private _data: IFeed = {
    credits: [],
    intro: [],
    partners: [],
    themes: []
  };
  private _isFetching: boolean = false;
  private _didFetchFailed?: boolean = undefined;
  private _themeId: number = -1;
  private _showBreadcrumb: boolean = true;
  private _otherThemesVisibility: boolean = false;
  private _otherThemesLabel: string = "general.other_themes";
  private _otherThemesAction: string = "themes";
  private _shareTestimonialVisibility: boolean = false;
  private _visitedTheme: number[] = [];
  private _currentTestimonial: any | undefined = undefined;
  private _finishExperience: boolean = false;

  get visitedThemes(): number[] {
    return this._visitedTheme;
  }


  get finishExperience ():boolean
  {
      return this._finishExperience;
  }

  get remainingThemes(): number {
    return this._data.themes.length - this.visitedThemes.length;
  }

  get breadcrumbVisibility(): boolean {
    return this._showBreadcrumb;
  }

  get otherThemesVisibility(): boolean {
    return this._otherThemesVisibility;
  }

  get otherThemesLabel(): string {
    return this._otherThemesLabel;
  }

  get otherThemesAction(): string {
    return this._otherThemesAction;
  }

  get shareTestimonialVisibility(): boolean {
    return this._shareTestimonialVisibility;
  }

  get didFetchFailed(): boolean | undefined {
    return this._didFetchFailed;
  }

  get isFetching(): boolean {
    return this._isFetching;
  }

  get data(): IFeed {
    return this._data;
  }

  get partners(): IPartner[] {
    return this._data?.partners ?? [];
  }

  get themes(): ITheme[] {
    return this._data?.themes ?? [];
  }

  get theme(): ITheme | null {
    return this._data?.themes.find(t => t.id === this._themeId) ?? null;
  }

  get credits() {
    return this._data?.credits ?? [];
  }

  get introductionPanels(): IIntroductionPanel[] {
    return this._data?.intro ?? [];
  }

  get currentTestimonialVisitorInfo() {

    return this._currentTestimonial.nav;
    // return this._data.currentTestimonialInfo;

    // const currentTestimonialInfo = {
    //   // other properties if needed
    //   nav: {
    //     themeTitle: "Current Theme Title",
    //     countTestimonialView: 2,
    //     countTestimonial: 6,
    //   }
    // }
    //
    // return currentTestimonialInfo.nav;
  }

  @Mutation
  private setData(data: IFeed): void {
    this._data = data;
    this._didFetchFailed = false;
    EventStore.triggerData(data);
  }

  @Mutation
  private setFetching(value: boolean) {
    this._isFetching = value;
  }

  @Mutation
  private setThemeId(id: number) {
    this._themeId = id;
  }

  @Mutation
  private handleError() {
    this._didFetchFailed = true;
  }

  @Mutation
  private setBreadcrumbStatus(show: boolean) {
    this._showBreadcrumb = show;
  }

  @Mutation
  private setOtherThemesStatus(show: boolean) {
    this._otherThemesVisibility = show;
  }

  @Mutation
  private setOtherThemesCopydeckLabel(strCopydeckLabel: string) {
    this._otherThemesLabel = strCopydeckLabel;
  }

  @Mutation
  private setOtherThemesActionType(strAction: string) {
    this._otherThemesAction = strAction;
  }


  @Mutation
  private setShareTestimonialStatus(show: boolean) {
    this._shareTestimonialVisibility = show;
  }

  @Mutation
  private _setVisitedThemes(ids: number[]) {
    this._visitedTheme = ids;
  }

  @Mutation
  private _setCurrentTestimonial(testimonial: any) {

      this._currentTestimonial = testimonial;
  }

  @Mutation
  public setFinishExperience (ended: boolean = true)
  {
    this._finishExperience = ended;
  }

  @Action
  setVisitedThemes(ids: number[]) {
    this._setVisitedThemes(ids);
  }

  @Action
  setTheme(id: number): void {
    this.setThemeId(id);
  }

  @Action
  setBreadcrumbVisibility(show: boolean): void {
    this.setBreadcrumbStatus(show);
  }

  @Action
  setCurrentTestimonial (testimonial:any):void
  {
    this._setCurrentTestimonial(testimonial);
  }

  @Action
  setOtherThemesVisibility(show: boolean): void {
    this.setOtherThemesStatus(show);
  }

  @Action
  setOtherThemesLabel(strCopydeckLabel: string): void {
    this.setOtherThemesCopydeckLabel(strCopydeckLabel);
  }

  @Action
  setOtherThemesAction(strAction: string): void {
    this.setOtherThemesActionType(strAction);
  }


  @Action
  setShareTestimonialVisibility(show: boolean): void {
    this.setShareTestimonialStatus(show);
  }

  @Action
  fetchData(): void {
    if (this.isFetching)
      return;

    this.setFetching(true);

    const endpoint: string = '/endpoints/memorial/data';
    //const endpoint: string = `../assets/feed.json`;

    axios.get(endpoint, {})
      .then(async (response) => {
        if (response.status != 200) {
          this.handleError();
          return;
        }

        this.setData(response.data);
      })
      .catch(() => {
        this.handleError();
      })
      .finally(() => {
        this.setFetching(false);
      });
  }
}
